import(/* webpackMode: "eager", webpackExports: ["DealerSearchResult"] */ "/opt/build/repo/app/components/shared/dealer/components/sections/search-result/index.tsx");
